module.exports = __webpack_public_path__ + "static/media/SENA HABUS.05426ef7.png";